import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ErrorNotificationService {
    private isErrorOccurred = new BehaviorSubject<boolean>(false);
    public isErrorOccurred$ = this.isErrorOccurred.asObservable();


    public markErrorOccurred(): void {
        if (this.isDevEnvironment()) {
            this.isErrorOccurred.next(true);
        }
    }

    private isDevEnvironment(): boolean {
        const host = window.location.hostname;
        return host === 'localhost' || host.startsWith('dev-');
    }
}
